/**
 * Calcula o preço unitário de um produto
 * @param {number} precoTotal - O preço total do produto
 * @param {number} unidadesPorPacote - Número de unidades no pacote
 * @returns {number} O preço unitário
 */
export function calcularPrecoUnitario(precoTotal, unidadesPorPacote) {
    if (!precoTotal || !unidadesPorPacote || unidadesPorPacote <= 1) {
        return null;
    }
    return precoTotal / unidadesPorPacote;
}

/**
 * Verifica se deve exibir preço unitário
 * @param {number} unidadesPorPacote - Número de unidades no pacote
 * @returns {boolean}
 */
export function deveExibirPrecoUnitario(unidadesPorPacote) {
    return unidadesPorPacote && Number(unidadesPorPacote) > 1;
}

/**
 * Formata o preço unitário para exibição
 * @param {number} precoTotal - O preço total do produto
 * @param {number} unidadesPorPacote - Número de unidades no pacote
 * @returns {string} Preço unitário formatado ou string vazia
 */
export function formatarPrecoUnitario(precoTotal, unidadesPorPacote) {
    if (!deveExibirPrecoUnitario(unidadesPorPacote)) {
        return '';
    }
    const precoUnitario = calcularPrecoUnitario(precoTotal, unidadesPorPacote);
    if (precoUnitario === null) {
        return '';
    }
    return `R$ ${Number(precoUnitario).toFixed(2)}`;
}
